import React, { useEffect, useRef } from 'react';
import '../styles/History.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Footer from '../components/Footer'; // Assuming shared footer

gsap.registerPlugin(ScrollTrigger);

const History = () => {
  const timelineRefs = useRef([]);

  // Milestones data
  const milestones = [
    {
      year: '2010',
      desc: 'Three Generations of Experience, Christopher John, Co-Owner of S&D Industrial Surplus, represents the third generation in the industrial surplus industry. His background is deeply rooted in oil and chemical processing plants as well as paper mills, where his family has built decades of expertise.'
    },
    {
      year: '2018',
      desc: 'Appliances to Industrial Surplus, Co-Owner Alex Mitchell began his entrepreneurial journey in 2018, founding and growing an appliance company. In 2019, he joined Christopher John in the industrial surplus space, learning the trade hands-on while expanding his focus to include surplus equipment, materials, and industrial parts.'
    },
    {
      year: '2021',
      desc: 'The Formation of S&D Industrial Surplus, In 2021, Alex Mitchell and Christopher John officially partnered to establish S&D Industrial Surplus. Together, they broadened their scope to include heavy industrial electrical equipment, strengthening the company’s ability to serve a wide range of industries.'
    },
    {
      year: '2022',
      desc: 'Growth and Industry Impact, Since its formation, S&D Industrial Surplus has secured numerous contracts and provided vital solutions across the industrial sector. From sourcing and supplying to buying and reselling, the company has supported oil, chemical, paper, infrastructure, and manufacturing industries with essential parts, machinery, property, and materials.'
    },
    {
      year: 'Today',
      desc: 'Expanding Our Footprint, Today, S&D Industrial Surplus operates from two primary locations — Houston, Texas, and Huntsville, Alabama. A new location in Decatur, Alabama is already in planning, furthering the company’s commitment to accessibility and growth in the Southeast.'
    }
  ];

  /* ------------------------------------------------------------------
     Timeline animations - Reveal on scroll
     ------------------------------------------------------------------ */
  useEffect(() => {
    timelineRefs.current.forEach((item) => {
      if (item) {
        ScrollTrigger.create({
          trigger: item,
          start: 'top 80%',
          onEnter: () => item.classList.add('visible'),
          once: true
        });
      }
    });

    // Force refresh to handle initial states immediately
    ScrollTrigger.refresh();
  }, []);

  return (
    <div className="lenis-content">
      {/* Hero Banner */}
      <section className="history-hero">
        <h1 className="history-hero__title">
          Our <span>Journey</span> Through Time
        </h1>
      </section>

      {/* Timeline Section */}
      <section className="history-timeline">
        <h2 className="section-heading">Key Milestones</h2>
        {milestones.map((milestone, index) => (
          <div 
            key={index} 
            className="timeline-item" 
            ref={el => timelineRefs.current[index] = el}
          >
            <div className="timeline-content">
              <h3 className="timeline-year">{milestone.year}</h3>
              <p className="timeline-desc">{milestone.desc}</p>
            </div>
            <div className="timeline-dot"></div>
          </div>
        ))}
      </section>

      {/* Global Footer */}
      <Footer />
    </div>
  );
};

export default History;